import { ArbolMenu } from "./arbol-menu";
import { NodoArbolMenu } from "./nodo-arbol-menu";
export class ArbolMenuHistorico{
    idMenu:string;
    arbol: ArbolMenu;
    currentNode: NodoArbolMenu;
    oldNodoArbolMenu: NodoArbolMenu;
    constructor(arbol:ArbolMenu, idMenu: string,currentNode: NodoArbolMenu,oldNodoArbolMenu: NodoArbolMenu){
        this.arbol = arbol;
        this.idMenu = idMenu;
        this.currentNode = currentNode;
        this.oldNodoArbolMenu = oldNodoArbolMenu;
    }

}